"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const theme_1 = require("../../theme");
const useNoOutlinedInputStyles = () => {
    const errorTextStyles = Object.assign(Object.assign({}, theme_1.theme.qlub.typography.caption_overline), { color: theme_1.theme.qlub.palette.danger.main, marginTop: '8px' });
    return {
        errorTextStyles,
    };
};
exports.default = useNoOutlinedInputStyles;
